import React, { useEffect, useState } from 'react';
import { List, Pane } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import LoadingScreen from "../../../support/LoadingScreen.js";
import Util from "./Util.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.group.Suggestions');
export default function Suggestions(props) {
  const [items, setItems] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const {
    delegate,
    filter,
    filterModel,
    objectType,
    renderAs,
    showSuggestionHelp,
    showSuggestionLoading,
    suggestionsVariant,
    search,
    onSearchChange,
    onClose,
    updateSuggestions,
    searchLongEnough,
    suggestionClass: Suggestion,
    searchDebounceMs,
    minSuggestionLength
  } = props;
  useEffect(() => {
    const opts = {
      setLoadingSuggestions,
      delegate,
      filterModel,
      search,
      setItems,
      objectType
    };
    const timer = setTimeout(() => {
      opts.setLoadingSuggestions(true);
      updateSuggestions(opts).then(() => opts.setLoadingSuggestions(false));
    }, searchDebounceMs);
    return () => {
      clearTimeout(timer);
      // this is required to prevent updates after we unmount
      opts.setLoadingSuggestions = Util.noOp;
      opts.setItems = Util.noOp;
    };
  }, [search, filter, setItems]);

  // if there are no items or our search is too short
  if (!items || items.length < 1 || !search ||
  // don't show suggestion help and the search is too short
  !showSuggestionHelp && !searchLongEnough(search)) {
    return null;
  }
  let suggestions = null;
  if (showSuggestionHelp && (!search || !searchLongEnough(search))) {
    suggestions = /*#__PURE__*/_jsx(Pane, {
      variant: "contentSection",
      layout: "flex:loadingScreen",
      children: t('minCharacters', {
        minSuggestionLength
      })
    });
  } else if (showSuggestionLoading && loadingSuggestions) {
    suggestions = /*#__PURE__*/_jsx(LoadingScreen, {
      title: "loadingSuggestions"
    });
  } else if (showSuggestionHelp && (!items || items.length < 1)) {
    suggestions = /*#__PURE__*/_jsx(Pane, {
      variant: "contentSection",
      layout: "flex:loadingScreen",
      children: t('noSuggestions')
    });
  } else {
    const itemProps = {
      search,
      onSearchChange,
      variant: suggestionsVariant,
      renderAs,
      onClose
    };
    const suggestionItems = items.map(item => /*#__PURE__*/_jsx(Suggestion, {
      item: item,
      ...itemProps
    }, item));
    suggestions = renderAs === 'list' ? /*#__PURE__*/_jsx(List, {
      variant: suggestionsVariant,
      children: suggestionItems
    }) : suggestionItems;
  }
  return suggestions;
}